(function ($) {
  Drupal.behaviors.artistrysLooksV1 = {
    attached: false,
    attach: function (context) {
      var self = this;
      var $formatter = $('.js-artistrys-looks-media-grid-v1', context);

      if (self.attached) {
        return;
      }
      self.attached = true;

      $formatter.each(function () {
        var $thisFormatter = $(this);

        var $carousel = $thisFormatter.find('.js-carousel');
        var carouselDataset = $carousel.data() || null;
        var slickSlide = '.js-carousel__slide';
        var $arrowsDiv = $thisFormatter.find('.js-carousel-controls');
        var $dotsDiv = $thisFormatter.find('.js-carousel-dots');
        var autoplay = carouselDataset.slidesAutoplay || false;
        var slidesToShow = carouselDataset.slidesToShow || 1;
        var slidesToScroll = carouselDataset.slidesToScroll || 1;
        var speed = carouselDataset.slidesSpeed || 300;
        var fade = carouselDataset.slidesFade ? true : false;
        var mobileDotsArrowsArgs = self.checkDotsAndArrows(carouselDataset.dotsArrowsMobile);
        var settingsPlain = {
          appendArrows: $arrowsDiv,
          slide: slickSlide,
          fade: fade,
          speed: speed,
          slidesToShow: slidesToShow,
          slidesToScroll: slidesToScroll,
          dots: mobileDotsArrowsArgs.dots,
          arrows: mobileDotsArrowsArgs.arrows,
          cssEase: 'cubic-bezier(.66, 0, .33, 1)'
        };
        var settingsResponsive = {
          appendArrows: $arrowsDiv,
          slide: slickSlide,
          fade: fade,
          speed: speed,
          slidesToShow: slidesToShow,
          slidesToScroll: slidesToScroll,
          autoplay: autoplay,
          infinite: false,
          cssEase: 'cubic-bezier(.66, 0, .33, 1)',
          dots: mobileDotsArrowsArgs.dots,
          arrows: mobileDotsArrowsArgs.arrows,
          appendDots: $dotsDiv,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                dots: mobileDotsArrowsArgs.dots,
                arrows: mobileDotsArrowsArgs.arrows,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        };
        var useResponsive = slidesToShow > 3 ? true : false;
        if (useResponsive === true) {
          $carousel.not('.slick-initialized').slick(settingsPlain);
        } else {
          $carousel.not('.slick-initialized').slick(settingsResponsive);
        }
      });
    },
    checkDotsAndArrows: function (dotsAndArrows) {
      var dotsArrowsArgs = {};

      switch (dotsAndArrows) {
        case 'arrows':
          dotsArrowsArgs.dots = false;
          dotsArrowsArgs.arrows = true;
          break;
        case 'dots':
          dotsArrowsArgs.dots = true;
          dotsArrowsArgs.arrows = false;
          break;
        case 'both':
          dotsArrowsArgs.dots = true;
          dotsArrowsArgs.arrows = true;
          break;
        case 'none':
          dotsArrowsArgs.dots = false;
          dotsArrowsArgs.arrows = false;
          break;
      }

      return dotsArrowsArgs;
    }
  };
})(jQuery);
